import { computed, Injectable, signal } from '@angular/core';
import { LotOrDeal, lotOrDeal, withDeal } from '@zayan-erp/shared';
import { DsmDealHeader } from '../models/dsm-aps.models';

@Injectable({ providedIn: 'root' })
export class DsmApsDealContextService {
  currentDeal = signal<DsmDealHeader | null>(null);
  reloadDeal = signal<boolean>(false);
  showConflictsOnly = signal<boolean>(false);

  hasAddendumsForPrint = signal<boolean>(false);
  isAllAddendumsSelectedForPrint = signal<boolean>(false);
  isSelectAllForPrintIndeterminate = signal<boolean>(false);
  toggleSelectAllForPrint = signal<((checked: boolean) => void) | null>(null);

  addendumsActionsWidth = signal<number>(0);

  effectiveLotId = computed(() => this.currentDeal()?.lot?.id ?? '');
  effectiveDealId = computed(() => this.currentDeal()?.id ?? '');

  /** Analytics context for a known dealId; attaches lot_id when currentDeal matches. */
  dealCtx(dealId: string): LotOrDeal {
    const deal = this.currentDeal();
    const lotId = deal?.id === dealId ? deal.lot?.id : undefined;
    return withDeal(dealId, lotId);
  }

  /** Analytics context from explicit ids and/or the open currentDeal. */
  currentDealCtx(ids?: { lotId?: string | null; dealId?: string | null }): LotOrDeal | null {
    const deal = this.currentDeal();
    return lotOrDeal({
      lotId: ids?.lotId ?? deal?.lot?.id,
      dealId: ids?.dealId ?? deal?.id
    });
  }
}
